import type { PermissionAction, PermissionFeature } from '@/utils/permissions';

export interface NavigationPermissionRequirement {
  feature: PermissionFeature;
  action: PermissionAction;
}

/** Any authenticated user can read their own permissions payload. */
export const AUTHENTICATED_SHELL_PERMISSION: NavigationPermissionRequirement = {
  feature: 'permissions_me',
  action: 'read',
};

/** Member app shell — client-owned profile surfaces. */
export const MEMBER_SHELL_PERMISSION: NavigationPermissionRequirement = {
  feature: 'user_profiles',
  action: 'read',
};

/** Corporate admin shell. */
export const CORPORATE_SHELL_PERMISSION: NavigationPermissionRequirement = {
  feature: 'corporate_accounts',
  action: 'list',
};
